/* ANIMUS · Lista de espera y pie → Klaviyo (API pública del navegador; la lista llega en data-list).
   Un solo oyente delegado en document: sigue funcionando cuando Shopify vuelve a pintar la ficha al cambiar de variante. */
(function () {
  if (window.__animusWaitlist) return;
  window.__animusWaitlist = true;

  var REVISION = '2025-07-15'; // revisión de la API de Klaviyo; si Klaviyo la retira, cambiar solo esta línea
  var MSG = {
    ok: 'Listo. Te avisamos cuando estén listos. Sin ruido.',
    bad: 'Revisa que el correo esté bien escrito.',
    fail: 'No pudimos guardarlo. Inténtalo de nuevo en un momento.'
  };

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-animus-waitlist]');
    if (!form) return;
    e.preventDefault();

    var input = form.elements.email;
    var btn = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-wl-status]');
    var email = input.value.trim();

    function say(text, ok) {
      status.textContent = text;
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }

    var okMsg = form.dataset.done || MSG.ok; // el pie trae su propio mensaje en data-done
    if (form.elements.website.value) { form.dataset.state = 'done'; status.textContent = okMsg; return; } // bot: se finge éxito
    if (!input.checkValidity() || !email) { say(MSG.bad, false); input.focus(); return; }

    btn.disabled = true;
    var props = {}; props[form.dataset.sourceProp || 'origen_lista_espera'] = form.dataset.source; // el pie usa origen_footer; la ficha agotada, origen_lista_espera
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: (form.dataset.sourceLabel || 'Lista de espera') + ' · ' + form.dataset.source,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      form.dataset.state = 'done';
      say(okMsg, true);
      // Medición: evento propio, sin correo. Un píxel personalizado puede reenviarlo a GA4 o Meta (marca/MEDICION-GA4-META.md).
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('animus_lista_espera', { origen: form.dataset.source, tipo: form.dataset.kind });
      status.focus();
    }).catch(function () {
      say(MSG.fail, false);
      btn.disabled = false;
    });
  });
})();
